const config = {
  apiUrl: "https://englishappbackend.onrender.com/",
};

export default config;